import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { color } from "@mui/system";

const metrics = [
  { label: "Total CI Ideas", value: 128 },
  { label: "Completed Projects", value: 67 },
  { label: "Average Time to Complete (days)", value: 14 },
  { label: "High Impact Ideas", value: 23 },
];

const chartData = [
  { month: "Jan", ideas: 10 },
  { month: "Feb", ideas: 18 },
  { month: "Mar", ideas: 23 },
  { month: "Apr", ideas: 20 },
  { month: "May", ideas: 30 },
];

const lineChartData = [
  { month: "Jan", projects: 5 },
  { month: "Feb", projects: 8 },
  { month: "Mar", projects: 12 },
  { month: "Apr", projects: 10 },
  { month: "May", projects: 15 },
];

export default function CIMetrics() {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          CI Metrics Dashboard
        </Typography>
        {/* Tab UI */}
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Overview" />
          <Tab label="Details" />
          <Tab label="Trends" />
        </Tabs>
      </Box>

      {tabValue === 0 && (
        <>
          {/* Metrics Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }} justifyContent={"center"}>
            {metrics.map((metric, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card elevation={2} sx={{ textAlign: "center" }}>
                  <CardContent>
                    <Typography variant="h5" fontWeight="bold">
                      {metric.value}
                    </Typography>
                    <Typography variant="body2">{metric.label}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Charts */}
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <Paper sx={{ p: 2, height: "100%" }}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  CI Ideas Submitted per Month
                </Typography>
                <ResponsiveContainer width={500} height={350}>
                  <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="ideas" fill="#4F46E5" />
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Paper sx={{ p: 2, height: "100%" }}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  Completed Projects per Month
                </Typography>
                <ResponsiveContainer width={500} height={350}>
                  <LineChart data={lineChartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Line type="monotone" dataKey="projects" stroke="#E63946" />
                  </LineChart>
                </ResponsiveContainer>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}

      {tabValue === 1 && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Detailed metrics and analysis will be displayed here.
        </Typography>
      )}

      {tabValue === 2 && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Trends and insights will be displayed here.
        </Typography>
      )}
    </Box>
  );
}
